import React                      from 'react';
import styled                     from 'styled-components';
import { DataTable }              from '@components/DataTable/DataTable';
import { TDataTableRow, IOption } from '@typings/components';
import { ISearchParams }          from '@typings/search';
import { TStatusFilterValue }     from '@typings/auction';
import { SearchPagination }       from '@components/SearchPagination/SearchPagination';
import { Dropdown }               from '@components/Dropdown/Dropdown';
import { SearchInput }            from '@components/SearchInput/SearchInput';
import { AUCTIONS_TABLE_HEADERS } from '../utils/tableHeaders';

const Wrapper = styled.div`
  max-width : 1680px;
  margin    : 0 auto;
`;

const FilterWrapper = styled.div`
  display         : flex;
  justify-content : space-between;
  margin          : 15px 0 40px;
`;

interface IProps {
  filterValues            : IOption[];
  selectedFilterValue     : TStatusFilterValue;
  handleSelectFilterValue : (prop: any) => void;
  totalAuctionsCount      : number;
  tableRows               : TDataTableRow[];
  currentPage             : number;
  rowsPerPage             : number;
  inputValue              : string;
  handleSearch            : (values: ISearchParams) => void;
  handleChangePage        : (page: number) => void;
  isLoading               : boolean;
}

export const AuctionsPage = ({
  filterValues,
  inputValue,
  selectedFilterValue,
  handleSelectFilterValue,
  tableRows,
  totalAuctionsCount,
  currentPage,
  rowsPerPage,
  handleSearch,
  handleChangePage,
  isLoading,
}: IProps): JSX.Element => (
  <Wrapper>
    <FilterWrapper>
      <Dropdown
        width               = {300}
        field               = {{ value: selectedFilterValue }}
        options             = {filterValues}
        customOnValueChange = {handleSelectFilterValue}
      />

      <SearchInput
        initialValue = {inputValue}
        handleSearch = {handleSearch}
        placeholder  = "Year, Make, Model, VIN# or partial VIN#"
        maxWidth     = "700px"
      />
    </FilterWrapper>

    <DataTable
      headers   = {AUCTIONS_TABLE_HEADERS}
      rows      = {tableRows}
      maxwidth  = "1680px"
      rowheight = "60px"
      loading   = {isLoading}
      aligntop
    />

    {!!totalAuctionsCount && (
      <SearchPagination
        totalItems       = {totalAuctionsCount}
        currentPage      = {currentPage}
        rowsPerPage      = {rowsPerPage}
        handleChangePage = {handleChangePage}
        maxWidth         = "100%"
      />
    )}
  </Wrapper>
);
